import Layout from '@/layout/index.vue'

export const educationMap = {
  path: '/education',
  component: Layout,
  meta: { title: '教务', code: 653654 },
  children: [
    {
      path: 'lessonPlan',
      component: () => import('@/views/education/index.vue'),
      meta: { title: '教学计划', code: 880451, drop: true },
      children: [
        {
          path: 'lessonPlan',
          component: () => import('@/views/education/index.vue'),
          meta: { title: '教学计划', code: 555728, drop: false },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/education/lessonPlan/index.vue'),
              meta: { title: '计划列表', keepAlive: true }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/education/lessonPlan/edit.vue'),
              meta: { title: '编辑教学计划' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/education/lessonPlan/detail.vue'),
              meta: { title: '教学计划详情' }
            }
          ]
        }
      ]
    },
    {
      path: 'teachingPlan',
      component: () => import('@/views/education/teachingPlan/index.vue'),
      meta: { title: '教案管理', code: 931368, drop: true },
      children: [
        {
          path: 'teachingPlan',
          component: () => import('@/views/education/teachingPlan/index.vue'),
          meta: { title: '教案管理', code: 869317, drop: true },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/education/teachingPlan/list.vue'),
              meta: { title: '教案列表' }
            },
            {
              path: 'addTeachingPlan/:op/:id/:pId',
              name: 'addTeachingPlan',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanAdd.vue'),
              meta: { title: '教案添加', code: '' }
            },
            {
              path: 'editTeachingPlan/:op/:id/:pId',
              name: 'editTeachingPlan',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanAdd.vue'),
              meta: { title: '教案编辑', code: '' }
            },
            {
              path: 'viewTeachingPlan/:op/:id/:pId',
              name: 'viewTeachingPlan',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanAdd.vue'),
              meta: { title: '教案查看', code: '' }
            },
            // -----------教案包----------
            {
              path: 'addPackage/:op/:id',
              name: 'addPackage',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanPackageAdd.vue'),
              meta: { title: '教案包添加' }
            },
            {
              path: 'editPackage/:op/:id',
              name: 'editPackage',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanPackageAdd.vue'),
              meta: { title: '教案包编辑' }
            },
            {
              path: 'viewPackage/:op/:id',
              name: 'viewPackage',
              component: () =>
                import('@/views/education/teachingPlan/teachingPlanPackageAdd.vue'),
              meta: { title: '教案包查看' }
            }
          ]
        },
        {
          path: 'teachTool',
          component: () => import('@/views/education/teachingPlan/teachingTool/index.vue'),
          meta: { title: '教具管理', code: 969208, drop: true },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/education/teachingPlan/teachingTool/list.vue'),
              meta: { title: '教具列表' }
            },
            {
              path: 'add/:op/:id',
              name: 'addTool',
              component: () =>
                import('@/views/education/teachingPlan/teachingTool/add.vue'),
              meta: { title: '教具添加' }
            },
            {
              path: 'edit/:op/:id',
              name: 'editTool',
              component: () =>
                import('@/views/education/teachingPlan/teachingTool/add.vue'),
              meta: { title: '教具编辑' }
            },
            {
              path: 'view/:op/:id',
              name: 'viewTool',
              component: () =>
                import('@/views/education/teachingPlan/teachingTool/add.vue'),
              meta: { title: '教具查看' }
            }
          ]
        }
      ]

    },
    {
      path: 'motionSchedule',
      component: () => import('@/views/education/motion/motionSchedule/index.vue'),
      meta: { title: '运动课程', code: 522438, drop: true },
      children: [
        {
          path: 'arrangeSchedule',
          meta: { title: '分组排课', code: 789042 },
          component: () =>
            import('@/views/education/motion/motionSchedule/arrangeSchedule/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/arrangeSchedule/list.vue'
                ),
              meta: { title: '分组排课', keepAlive: true }
            },
            {
              path: 'add',
              name: 'GroupAdd',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/arrangeSchedule/add.vue'
                ),
              meta: { title: '新建运动分组' }
            },
            {
              path: 'edit/:id',
              name: 'GroupEdit',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/arrangeSchedule/add.vue'
                ),
              meta: { title: '编辑运动分组' }
            }
          ]
        },
        {
          path: 'classSchedule',
          meta: { title: '班级排课', code: 703998 },
          component: () =>
            import('@/views/education/motion/motionSchedule/classSchedule/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/classSchedule/list.vue'
                ),
              meta: { title: '班级排课', keepAlive: true }
            },
            {
              path: 'add',
              name: 'GroupAdd',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/classSchedule/add.vue'
                ),
              meta: { title: '新建排课' }
            },
            {
              path: 'edit/:id',
              name: 'GroupEdit',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/classSchedule/add.vue'
                ),
              meta: { title: '编辑排课' }
            }
          ]
        },
        {
          path: 'arrangeStudent',
          meta: { title: '学员管理', code: 907015 },
          component: () =>
            import('@/views/education/motion/motionSchedule/arrangeStudent/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/arrangeStudent/list.vue'
                ),
              meta: { title: '学员管理', keepAlive: true }
            },
            {
              path: 'detail',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/arrangeStudent/detail.vue'
                ),
              meta: { title: '学员详情' }
            }
          ]
        },
        {
          path: 'course',
          meta: { title: '运动课表', code: 667947 },
          component: () =>
            import('@/views/education/motion/motionSchedule/topicCourse/index.vue'),
          children: [
            {
              path: 'courseList',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/topicCourse/courseList.vue'
                ),
              meta: { title: '课程列表', keepAlive: true }
            },
            {
              path: 'timeTableList',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/topicCourse/lessonTimeTableList.vue'
                ),
              meta: { title: '课程表列表' }
            },
            {
              path: 'timeTableDetailList',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/topicCourse/lessonTimeTableDetaileList.vue'
                ),
              meta: { title: '课程表详情' }
            },
            {
              path: 'lessonDetail',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/topicCourse/lessonInfo.vue'
                ),
              meta: { title: '课时详情' }
            }
          ]
        },
        {
          path: 'classCourse',
          meta: { title: '班级课表', code: 806322 },
          component: () =>
            import('@/views/education/motion/motionSchedule/classCourse/index.vue'),
          children: [
            {
              path: 'classCourseList',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/classCourse/list.vue'
                ),
              meta: { title: '课表列表', keepAlive: true }
            }
          ]
        },
        {
          path: 'group',
          meta: { title: '分组课表', code: 376327 },
          component: () =>
            import('@/views/education/motion/motionSchedule/groupSchedule/index.vue'),
          children: [
            {
              path: 'groupList',
              component: () =>
                import(
                  '@/views/education/motion/motionSchedule/groupSchedule/list.vue'
                ),
              meta: { title: '课表列表', keepAlive: true }
            }
          ]
        }
      ]
    },
    {
      path: 'homeCourse',
      component: () => import('@/views/education/index.vue'),
      meta: { title: '居家课程', drop: true, code: 851585 },
      children: [
        {
          path: 'coursePush',
          component: () => import('@/views/education/homeCourse/coursePush/index.vue'),
          meta: { title: '课程推送', code: 875244 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/education/homeCourse/coursePush/list.vue'),
              meta: { title: '课程推送', keepAlive: true, code: '' }
            }
          ]
        },
        {
          path: 'studentSchedule',
          component: () => import('@/views/education/homeCourse/studentSchedule/index.vue'),
          meta: { title: '学员课表', code: 889715 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/education/homeCourse/studentSchedule/list.vue'),
              meta: { title: '学员课表', keepAlive: true, code: '' }
            }
          ]
        },
        {
          path: 'signInfo',
          component: () => import('@/views/education/homeCourse/signInfo/index.vue'),
          meta: { title: '打卡详情', keepAlive: true, code: 264973 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/education/homeCourse/signInfo/list.vue'),
              meta: { title: '打卡列表', code: 359269 }
            },
            {
              path: 'detail',
              component: () => import('@/views/education/homeCourse/signInfo/detail.vue'),
              meta: { title: '详情', code: 359269 }
            },
            {
              path: 'statistics',
              component: () => import('@/views/education/homeCourse/signInfo/statistics.vue'),
              meta: { title: '个人统计', code: 359269 }
            }
          ]
        },
        {
          path: 'signStatistics',
          component: () => import('@/views/education/homeCourse/signStatistics/index.vue'),
          meta: { title: '打卡统计', keepAlive: true, code: 567485 },
          children: [

            {
              path: 'statistics',
              component: () => import('@/views/education/homeCourse/signStatistics/statistics.vue'),
              meta: { title: '', code: 567485 }
            },
            {
              path: 'detail',
              component: () => import('@/views/education/homeCourse/signStatistics/detail.vue'),
              meta: { title: '详情', code: 843470 }
            }
          ]
        },
        {
          path: 'signAnalysis',
          component: () => import('@/views/education/homeCourse/signAnalysis/index.vue'),
          meta: { title: '打卡分析', keepAlive: true, code: 828284 },
          children: [

            {
              path: 'statistics',
              component: () => import('@/views/education/homeCourse/signAnalysis/statistics.vue'),
              meta: { title: '', keepAlive: true, code: 828284 }
            },
            {
              path: 'detail',
              component: () => import('@/views/education/homeCourse/signAnalysis/detail.vue'),
              meta: { title: '', code: 728045 }
            },
            {
              path: 'detail2',
              component: () => import('@/views/education/homeCourse/signAnalysis/detail2.vue'),
              meta: { title: '详情', code: 728045 }
            }
          ]
        },
        {
          path: 'point',
          meta: { title: '积分设置', code: 169640 },
          component: () =>
            import('@/views/education/homeCourse/point/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import(
                  '@/views/education/homeCourse/point/list.vue'
                ),
              meta: { title: '积分获取规则', code: 118930, keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import(
                  '@/views/education/homeCourse/point/add.vue'
                ),
              meta: { title: '新建积分规则', code: 447361 }
            },
            {
              path: 'edit',
              component: () =>
                import(
                  '@/views/education/homeCourse/point/add.vue'
                ),
              meta: { title: '编辑积分规则', code: 447361 }
            }
          ]
        }
      ]
    }
  ]
}
